export default __webpack_public_path__ + "i18n/pl.d1a49ccdcb53f48685dbf476ecc4bc21.json";